import React, { ReactElement } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { Heading } from "web/react/emo/heading";
import { Sticker } from "web/react/emo/sticker";
import { Text } from "web/react/emo/text";
import { VStack } from "web/react/emo/v-stack";
import { View } from "web/react/emo/view";
import { gettext } from "web/script/modules/django-i18n";
import {
    CheckoutOrderHistorySerializer,
    PaginatedCheckoutOrderHistorySerializer,
} from "web/types/serializers";
import * as styles from "./order-history.css";

function NoOrders(): ReactElement {
    return (
        <View padding="lg">
            <VStack spacing="md" align="center">
                <SVGIcon name="shopping-basket" className={styles.icon} />
                <VStack spacing="sm" align="center">
                    <Text as="p" textStyle="hero-s">
                        {gettext("order_history.no_orders.title")}
                    </Text>
                    <VStack spacing="none" align="center">
                        <Text as="p" textStyle="body-s">
                            {gettext("order_history.no_orders.description1")}
                        </Text>
                        <Text as="p" textStyle="body-s">
                            {gettext("order_history.no_orders.description2")}
                        </Text>
                    </VStack>
                    <Text as="p" textStyle="body-s">
                        {gettext("order_history.no_orders.description3")}
                    </Text>
                    <Sticker name="lystShopPartner" />
                </VStack>
            </VStack>
        </View>
    );
}

// temp disabled until next ticket implemented
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function OrderList(orders: { orders: CheckoutOrderHistorySerializer[] }): ReactElement {
    // console.warn(orders)

    return (
        <>
            <Heading as="h2" textStyle="hero" className={styles.heading}>
                {gettext("order_history.orders.title")}
            </Heading>

            <section style={{ border: "1px solid black", marginTop: "2rem" }}>
                {"Order History is coming soon !"}
            </section>
        </>
    );
}

export function OrderHistory({ results }: PaginatedCheckoutOrderHistorySerializer): ReactElement {
    const hasOrders = results && results.length > 0;

    return (
        <div className={styles.content}>
            {hasOrders ? <OrderList orders={results} /> : <NoOrders />}
        </div>
    );
}
